import { envVars } from '@/config';
import { maodalities } from '@/mocks/modality';
import type { IGetModalityReq, IGetModalityRes } from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchCustomBaseQuery } from '../fetcher';

export const modalityApi = createApi({
  reducerPath: 'modalityApi',
  baseQuery: fetchCustomBaseQuery({
    baseUrl: envVars.backendUrl,
    mock: false,
  }),
  tagTypes: ['modality'],
  endpoints: (builder) => ({
    getModality: builder.query<IGetModalityRes['data']['modalities'], IGetModalityReq>({
      query: () => ({
        url: '/general/modalities',
        isProtected: false,
        forceMock: false,
        mockData: {
          message: 'Modality fetched Successfully',
          data: { maodalities },
        },
      }),
      transformResponse: (response: IGetModalityRes) => {
        const data = response?.data?.modalities ?? [];
        const mapping: Record<string, string> = {
          male: 'Masculino',
          female: 'Feminino',
        };
        return data.flatMap(
          (item) =>
            item.available_genders?.map((gender) => ({
              ...item,
              gender,
              name: `${item.name} ${mapping[gender]}`,
            })) ?? [item],
        );
      },
    }),
  }),
});

export const { useGetModalityQuery } = modalityApi;
